export default __webpack_public_path__ + "static/media/24.c77759c0.jpg";